import { LogoProps } from './Logo.types'
import LogoStyled from './Logo.styles'

const Logo = ({ className = '', styles, ...props }: LogoProps) => {
  return <LogoStyled className={`Logo ${className}`} sx={styles} {...props} />
}

export default Logo
